import { defineNuxtPlugin } from "nuxt/app";
import errorShake from "@/directives/errorShake";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("error-shake", errorShake);
});
